import { ApolloLink } from "@apollo/client";
const userAgentLink = new ApolloLink((operation, forward)=>{
    if ("u" < typeof window) operation.setContext(({ headers = {} })=>({
            headers: {
                ...headers,
                'user-agent': 'Crehana-Vercel'
            }
        }));
    return forward(operation);
});
const links_userAgentLink = userAgentLink;
export default links_userAgentLink;
